import { Component, Input } from '@angular/core';

@Component({
  selector: 'sca-card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.scss']
})
export class CardViewComponent {
  @Input('cardTitle') cardTitle: string = '';
  @Input('contentCssClass') contentClass: string = '';

  @Input('hideDivider') hideDivider: boolean = false;
}
